module.exports = __webpack_public_path__ + "media/promo/courses/images/olegstructm-117b434c5ae6daaaea8ee3fd27ca91b1.jpg";